<template>
  <div class="container" style="max-width: 700px;">

    <!-- top -->
    <div class="tac pb-4 pt-5">
      <div>
        <h2 class="mb-2">
          Deposit {{data.stake_token_name}} and earn {{data.earn_token_name}}
        </h2>
        <p v-if="0" style="font-size: 18px;">
          Earn {{data.token_earn}} tokens by staking {{data.token_symbol}} Tokens.
        </p>
      </div>
    </div>

    <!-- <router-link :to="{name: 'farms'}" class="btn btn-primary outlined">
      Back
    </router-link> -->

    <div class="row pt-4">
      <div class="col-md-6">

        <div class="ui-card tac px-3 py-4 mb-5">
          <div class="main-body">
            <div class="ui-emoji-logo">
              {{data.earn_token_emoji}}
            </div>
            <div class="my-4">
              <h1>
                {{num_earned | tofixed3 | qfw}}
              </h1>
              <p class="op8">
                {{data.earn_token_name}}  earned
              </p>
            </div>
          </div>
          <div>
            <button class="ui-btn w-100 size-lg" @click="btnHarvestClicked()">
              Harvest
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6">

        <div class="ui-card tac px-3 py-4 mb-5">
          <div class="main-body">
            <div class="ui-emoji-logo">
              {{data.stake_token_emoji}}
            </div>
            <div class="my-4">
              <h1>
                {{num_stacked | tofixed3 | qfw}}
              </h1>
              <div class="op8">
                {{data.stake_token_name}} staked
              </div>
            </div>
          </div>

          <div v-if="!status_account_approved" class="d-flex">
            <button class="ui-btn w-100 size-lg mr-1" @click="btnApproveClicked()">Approve</button>
          </div>
          <div v-if="status_account_approved" class="d-flex">
            <button class="ui-btn w-100 size-lg mr-1" @click="status_show_modal_stake = true">
              Stake
            </button>

            <button class="ui-btn w-100 size-lg ml-1" @click="status_show_modal_unstake = true">
              Unstake
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- stake modal -->
    <UiModal :open="status_show_modal_stake" @close="status_show_modal_stake = false">
      <h3 class="m-4 mb-0 text-center">Stake</h3>
      <div class="px-4 pb-4">
        <div class="input-group mb-3">
          <input v-model="input_num_stake" type="text" class="form-control form-control-lg border-right-none" placeholder="0.0">
          <div class="input-group-append">
            <span class="input-group-text cp bg-white">
              <span @click="setInputNumStakeMax()" class="btn btn-outline-primary btn-sm">
                Max
              </span>
            </span>
          </div>
          <div class="input-group-append">
            <span class="input-group-text">
              {{data.stake_token_name}}
            </span>
          </div>
        </div>
        <button class="btn btn-primary w-100" @click="btnStakeClicked()">
          Stake
        </button>
      </div>
    </UiModal>

    <!-- unstake modal -->
    <UiModal :open="status_show_modal_unstake" @close="status_show_modal_unstake = false">
     <h3 class="m-4 mb-0 text-center">Unstake</h3>
     <div class="px-4 pb-4">
       <div class="input-group mb-3">
          <input v-model="input_num_unstake" type="text" class="form-control form-control-lg border-right-none" placeholder="0.0">
          <div class="input-group-append">
            <span class="input-group-text cp bg-white">
              <span @click="setInputNumUnstakeMax()" class="btn btn-outline-primary btn-sm">
                Max
              </span>
            </span>
          </div>
          <div class="input-group-append">
            <span class="input-group-text">
              {{data.stake_token_name}}
            </span>
          </div>
        </div>
        <button class="btn btn-primary w-100" @click="btnUnstakeClicked()">
          Unstake
        </button>
     </div>
    </UiModal>
  </div>
</template>

<script>
// 【注意1：引入 mapActions 方法】
import { mapActions } from 'vuex';
import data_main_list from './data_vaults_list.js'

export default {
  name: 'farmsItem',
  components: {},
  props: [],
  data() {
    return {
      status_show_modal_stake: false,
      status_show_modal_unstake: false,

      num_earned: '-',
      num_stacked: '-',

      input_num_stake: '',
      input_num_unstake: this.$store.state.web3.account_balance_lp || '',
    }
  },
  computed: {
    data(){
      let v = this
      let id = v.$route.params.id || 'default'
      return data_main_list.find(item => item.id === id)
    },
    status_account_approved(){
      return this.$store.state.web3.status_account_approved
    },
  },
  watch: {
    '$store.state.web3.account'(){
      this.run()
    },
    '$store.state.web3.account_balance_lp'(val,old_val){
      if(!old_val){
        this.input_num_unstake = val
      }
    },
  },
  methods: {
    // 【注意2：用 mapActions 引用具体方法(数组、字符串)】
    ...mapActions([
      'getBalance',
      'hasApproveLP',
      'approveLP',
      'getHasStakeBalance',
      'getLPBalance',
      'stakeLP',
      'unStakeLP',
      'getPendingReward',
      'harvest',
    ]),

    setInputNumStakeMax(){
      let v = this
      v.input_num_stake = v.$store.state.web3.account_balance_lp
    },
    setInputNumUnstakeMax(){
      let v = this
      v.input_num_unstake = v.num_stacked
    },

    //
    async btnHarvestClicked(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}

      v.harvest({
        callback: function(){
          v.run()
        }
      })
    },

    async checkAccountApprove(){
      let v = this
      let mark = await v.hasApproveLP(v.$store.state.web3.account)
      mark = mark ? true : false

      // 更新
      v.$store.commit('setWeb3Data',{
        status_account_approved: mark,
      })
    },

    btnApproveClicked(){
      let v = this
      v.approveLP()
    },

    async btnStakeClicked(){
      let v = this
      let num = v.input_num_stake
      v.stakeLP({
        num: num,
        callback: function(){
          v.status_show_modal_stake = false
          v.run()
        }
      })
    },

    async btnUnstakeClicked(){
      let v = this
      let num = v.input_num_unstake
      v.unStakeLP({
        num: num,
        callback: function(){
          v.status_show_modal_unstake = false
          v.run()
        }
      })
    },

    async getNumStacked(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}
      let num = await v.getHasStakeBalance(address)
      v.num_stacked = num
      v.input_num_unstake = num
    },
    async getNumEarned(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}
    },

    async getAccountBalanceLp(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}
      let num = await v.getLPBalance(address)

      // 保存lp余额
      v.$store.commit('setWeb3Data',{
        account_balance_lp: num,
      })
      v.input_num_stake = num
    },

    async getNumEarned(){
      let v = this
      let address = v.$store.state.web3.account
      if(!address){return}

      v.num_earned = await v.getPendingReward(address)
    },


    async run(){
      let v = this
      v.checkAccountApprove()
      v.getNumStacked()
      v.getNumEarned()
      v.getAccountBalanceLp()
      v.getNumEarned()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .ui-card{
    .main-body{
      min-height: 220px;
    }
  }
</style>